import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImac: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="imac, computer" maskId="round-filled-radius-1-stroke-1.5-IconImac"><path d="M3.75 3C2.7835 3 2 3.7835 2 4.75V12.5H22V4.75C22 3.7835 21.2165 3 20.25 3H3.75Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M2 16.25V14H22V16.25C22 17.2165 21.2165 18 20.25 18H15V21.25C15 21.6642 14.6642 22 14.25 22H9.75C9.33579 22 9 21.6642 9 21.25V18H3.75C2.7835 18 2 17.2165 2 16.25ZM10.5 18V20.5H13.5V18H10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImac;
